export const accent = {
    black: '#111111',
    white: '#FFFFFF',

    accent100: '#F9F9F9',
    accent200: '#F5F5F5',
    accent300: '#ECECEC',
    accent400: '#E4E4E4',
    accent500: '#DDDDDD',
    accent600: '#D5D5D5',
    accent700: '#C9C9C9',
    accent800: '#B7B7B7',
    accent900: '#111111',
    accent1000: '#2A2A2A',
    accent1100: '#5F5F5F',
    accent1200: '#1F1F1F',

    accentAccentContrast: '#FFFFFF',
    accentAccentSurface: '#f6f6f6',
};

export const accentAlpha = {
    black: 'rgba(0,0,0,0.9333)',
    white: 'rgba(0,0,0,0.0118)',

    accent100: 'rgba(0,0,0,0.0118)',
    accent200: 'rgba(0,0,0,0.0275)',
    accent300: 'rgba(0,0,0,0.0627)',
    accent400: 'rgba(0,0,0,0.0941)',
    accent500: 'rgba(0,0,0,0.1216)',
    accent600: 'rgba(0,0,0,0.1529)',
    accent700: 'rgba(0,0,0,0.2039)',
    accent800: 'rgba(0,0,0,0.2745)',
    accent900: 'rgba(0,0,0,0.9333)',
    accent1000: 'rgba(0,0,0,0.8353)',
    accent1100: 'rgba(0,0,0,0.6235)',
    accent1200: 'rgba(0,0,0,0.8784)',

    accentAccentContrast: 'rgba(255,255,255,1)',
    accentAccentSurface: '#rgba(244, 244, 244, 0.8);',
};

export const accentDark = {
    black: '#F9F9F9',
    white: '#111111',

    accent100: '#111111',
    accent200: '#191919',
    accent300: '#232323',
    accent400: '#2A2A2A',
    accent500: '#313131',
    accent600: '#3A3A3A',
    accent700: '#484848',
    accent800: '#616161',
    accent900: '#FCFCFC',
    accent1000: '#F3F3F3',
    accent1100: '#B4B4B4',
    accent1200: '#EEEEEE',

    accentAccentContrast: '#ffffff',
    accentAccentSurface: '#101010',
};

export const accentDarkAlpha = {
    black: 'rgba(255,255,255,0.9882)',
    white: 'rgba(255,255,255,0.0111)',

    accent100: 'rgba(255,255,255,0.0111)',
    accent200: 'rgba(255,255,255,0.0353)',
    accent300: 'rgba(255,255,255,0.0745)',
    accent400: 'rgba(255,255,255,0.1059)',
    accent500: 'rgba(255,255,255,0.1333)',
    accent600: 'rgba(255,255,255,0.1725)',
    accent700: 'rgba(255,255,255,0.2314)',
    accent800: 'rgba(255,255,255,0.3373)',
    accent900: 'rgba(255,255,255,0.9882)',
    accent1000: 'rgba(255,255,255,0.9490)',
    accent1100: 'rgba(255,255,255,0.6863)',
    accent1200: 'rgba(255,255,255,0.9294)',

    accentAccentContrast: 'rgba(255,255,255,1)',
    accentAccentSurface: 'rgba(0, 0, 0, 0.8)',
};
